import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';
import { useOrg } from '../context/OrgContext';
import { Button } from '../components/core';
import DashboardPage from './DashboardPage';
import { SuperAdminOrgInvites } from './SuperAdminOrgInvites';

export default function SuperAdminOrgView() {
  const navigate = useNavigate();
  const { appUser } = usePermissions();
  const { org, isReadOnly } = useOrg();

  // Only super admins can view this page
  if (!appUser?.isSuperAdmin || !isReadOnly) {
    return null;
  }

  return (
    <div className="min-h-screen bg-green-50">
      {/* Super Admin Banner */}
      <div className="sticky top-0 z-40 bg-amber-600 px-6 py-3 text-white shadow-sm">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="text-lg">👁</span>
            <div>
              <span>Viewing <strong>{org.name}</strong> as Super Admin &mdash; read only</span>
            </div>
          </div>
          <Button
            variant="secondary"
            size="sm"
            onClick={() => navigate('/admin')}
          >
            ← Back to Admin
          </Button>
        </div>
      </div>

      {/* Secondary info banner */}
      <div className="border-b border-amber-200 bg-amber-50 px-6 py-3">
        <div className="mx-auto flex max-w-6xl items-center gap-2 text-sm text-amber-900">
          <span>🔒</span>
          <span>All write operations are disabled. You can browse this org&apos;s data but cannot make changes.</span>
        </div>
      </div>

      {/* Main content */}
      <div className="mx-auto max-w-6xl px-4 py-6 sm:px-6">
        {/* Pending invites section */}
        <div className="mb-8">
          <h2 className="mb-4 font-display text-lg font-semibold text-gray-900">Pending Invites</h2>
          <SuperAdminOrgInvites />
        </div>

        {/* Dashboard content in read-only mode */}
        <div>
          <h2 className="mb-4 font-display text-lg font-semibold text-gray-900">Organization Dashboard</h2>
          <DashboardPage />
        </div>
      </div>
    </div>
  );
}
